import { types } from "@/BaseComponent";
import { defineStore } from "pinia";
const popupStore = defineStore("popup", {
    state: () => {
        return {
            list: [] as Array<types.ResPopupBannerVOForApi>,
            hiddenList: {} as any,
        };
    },
    actions: {
        setList(list: Array<types.ResPopupBannerVOForApi>) {
            this.list = list;
        },
        loadHiddenList() {
            const saved = localStorage.getItem("hiddenPopups");
            this.hiddenList = saved ? JSON.parse(saved) : {};
        },
        getVisiblePopups() {
            const today = new Date().toISOString().slice(0, 10);
            return this.list.filter((p: types.ResPopupBannerVOForApi) => this.hiddenList[p.idx] !== today);
        },
        hidePopupForToday(popupId: number) {
            const today = new Date().toISOString().slice(0, 10);
            this.hiddenList[popupId] = today;
            localStorage.setItem("hiddenList", JSON.stringify(this.hiddenList));
        },
    },
});

export default popupStore;
